import React from 'react';
import styled from 'styled-components';
import RCore from 'RCore';

import config from 'cfg';
import MatchScore from './MatchScore';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Substitution } from './IncidentWithPhotos';
import { PlayerLogo3DJerseyBack as PlayerLogo } from '../../../components/sm/views/playerLogo/SMPlayerLogo';
const i18dict = RCore.i18Register(require('../../../i18/i18.IncidentWidget.js'), {});
const i18 = RCore.getTranslation.bind({ dict: i18dict });

const IncidentStyle = styled.div`
    .player-logo {
        position: absolute;
        right: 50px;
        bottom: 130px;
    }
`;
const GoalTitle = styled.div`
    color: ${props => props.color || props.theme.titleColor || props.theme.color};
    font-weight: 700;
    font-size: 150px;
    line-height: 159px;
    font-weight: 700;
    white-space: nowrap;
`;

const MainContent = styled.div`
    position: absolute;
    text-align: center;
    bottom: 150px;
    width: 460px;
    left: ${props => props.theme.contentPadding}px;
`;

const CardWrapper = styled.div`
    transform: rotate(10deg);
    height: 140px;
    display: inline-block;
    margin: 0 auto 25px;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    overflow: hidden;
    img {
        height: 100%;
        width: auto;
    }
`;

const MatchScoreWrapper = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100px;
    background: ${props => props.theme.content.backgroundColor};
    color: ${props => props.theme.color};
    display: flex;
    align-items: center;
    padding-left: ${props => props.theme.contentPadding}px;
    .sm-match-score {
        width: 460px;
        padding: 0 35px;
        box-sizing: border-box;
    }
`;

const PlayerInfo = styled.div`
    text-align: center;
    color: ${props => props.theme.color};
    text-transform: uppercase;
`;

const PlayerName = styled.div`
    font-size: ${props => props.fontSize || 40}px;
    font-weight: 700;
    line-height: 42px;
    margin-bottom: 8px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

// const PlayerPhoto = styled.div`
//     height: 470px;
//     overflow: hidden;
//     position: absolute;
//     right: 0;
//     bottom: 0;
//     img {
//         height: 100%;
//         width: auto;
//     }
//     .wdp-sm-plr-logo_jersey,
//     .wdp-sm-plr-logo_3d_jersey_front {
//         height: 100%;
//         width: 230px;
//         margin-right: ${props => props.theme.contentPadding}px;
//         margin: ${props => `-${props.theme.contentPadding}px ${props.theme.contentPadding}px 0 0`};
//     }
//     .wdp-sm-plr-logo_3d_jersey_front {
//         height: auto;
//         margin-top: 60px;
//     }
// `;

const IncidentMinute = styled.div`
    ${props => `color: ${props.incidentMinuteColor};`} text-align: center;
    font-size: 35px;
    line-height: 42px;
`;

const Incident = styled.div`
    text-transform: uppercase;
    .player {
        font-size: 34px;
    }
    .ic-player__surname {
        font-size: 36px;
        font-weight: bold;
    }
`;

const Player = ({ teamId, player, card, event, incidentMinuteColor, incidentMinute }, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');
    const name = RCore.playerShortName(player.name);
    const fontSize = name.length >= 15 ? 30 : 40;
    return (
        <PlayerInfo>
            <PlayerName fontSize={fontSize}>{name}</PlayerName>
            <IncidentMinute>
                {incidentMinute} {i18('min', lang)}.
            </IncidentMinute>
        </PlayerInfo>
    );
};

const Goal = (props, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');
    return (
        <Incident>
            <GoalTitle>{i18('title.goal', lang)}</GoalTitle>
            <Player {...props} />
        </Incident>
    );
};

const Assist = (props, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');
    return (
        <Incident>
            <GoalTitle style={{ fontSize: 75, lineHeight: '80px', marginBottom: 7 }}>
                {i18('title.assist', lang)}
            </GoalTitle>
            <Player {...props} />
        </Incident>
    );
};

const OwnGoal = (props, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');
    return (
        <Incident>
            <GoalTitle style={{ fontSize: 75, lineHeight: '80px', marginBottom: 7 }} color={props.incidentMinuteColor}>
                {i18('title.owngoal', lang)}
            </GoalTitle>
            <Player {...props} />
        </Incident>
    );
};

const Card = props => {
    const card =
        props.cardName === 'yellow_card' ? (
            <img src={`${config.assets}/assets/yellow_card_gradient.png`} alt="yellow" />
        ) : (
            <img src={`${config.assets}/assets/red_card_gradient.png`} alt="red" />
        );
    return (
        <Incident>
            <CardWrapper>{card}</CardWrapper>
            <Player {...props} />
        </Incident>
    );
};

const Wrapper = props => {
    const { children, event, incidentId, matchScore, incident, player } = props;
    //
    let teamId = incident.teamId;
    // swap team id, as incident teamId shows who will get a score
    if (matchScore.isOwnGoal) {
        teamId = props.incident.teamId === props.event.homeId ? props.event.awayId : props.event.homeId;
    }

    return (
        <IncidentStyle>
            <MainContent>{children}</MainContent>
            <PlayerLogo
                width={220}
                className="player-logo"
                display="3d_jersey_back"
                number={_.get(player, 'shirtNumber')}
                playerId={player.id}
                seasonId={event.tournamentId}
                teamId={teamId}
            />

            <MatchScoreWrapper>
                <MatchScore {...matchScore} event={event} view="nameLogoScore" incidentId={incidentId} />
            </MatchScoreWrapper>
        </IncidentStyle>
    );
};

Goal.contextTypes = {
    info: PropTypes.object
};

Wrapper.contextTypes = {
    info: PropTypes.object
};
Assist.contextTypes = {
    info: PropTypes.object
};
OwnGoal.contextTypes = {
    info: PropTypes.object
};
Card.contextTypes = {
    info: PropTypes.object
};
Player.contextTypes = {
    info: PropTypes.object
};

export default {
    Wrapper,
    Goal,
    Assist,
    OwnGoal,
    Card,
    Substitution,
    disableBranding: true
};
export { Wrapper, Goal, Assist, OwnGoal, Card, Substitution };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/IncidentStyle3.js
 **/